module.exports = __webpack_public_path__ + "media/images/board-douglas-278a9222.png";